/* eslint-disable import/no-anonymous-default-export */
import client from "./Client";

const getStaff = (schoolId) =>
  client.get(`/staff/school/${schoolId}/staff`);

const getSingleStaff = (staffId, schoolId) =>
  client.get(`/${schoolId}/staff/${staffId}`);

const getStaffProfile = (staffId, schoolId) =>
  client.get(`/staff/school/${schoolId}/staff/${staffId}/profile`);

const updatePassword = (
  staff_id = "",
  current_password = "",
  new_password = "",
  confirm_password = ""
) =>
  client.post(
    `/staff/settings/password/update`,
    {
      staff_id,
      current_password,
      new_password,
      confirm_password,
    }
  );

const getStudentAssessmentPerformance = (school_id) =>
  client.get(`/staff/school/${school_id}/stat/students/assessment`, {
    headers: {
      "Content-Type": "application/json",
    },
  });

const getSchoolAssessmentsData = (school_id) =>
  client.get(`/staff/school/${school_id}/classes/students/assessments-data`);

export default {
  getStaff,
  getSingleStaff,
  getStaffProfile,
  updatePassword,
  getStudentAssessmentPerformance,
  getSchoolAssessmentsData,
};
